module.exports = __webpack_public_path__ + "static/media/bloodkin_logo.21f4dcfb.png";